import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { FiArrowLeft, FiCopy } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import NoIndexSEO from "../../../components/SEO/NoIndexSEO";
import { seoConfig } from "../../../utils/seoConfig";
import "./referral.scss";
import QRCode from "react-qr-code";

import { ReactComponent as Facebook } from "../../../assets/images/referral/facebook.svg";
import { ReactComponent as Twitter } from "../../../assets/images/referral/twitter.svg";
import { ReactComponent as Linkedin } from "../../../assets/images/referral/linkedin.svg";
import { ReactComponent as Mail } from "../../../assets/images/referral/mail.svg";
import { ReactComponent as Friend } from "../../../assets/images/referral/add-friend.svg";
import { ReactComponent as Share } from "../../../assets/images/referral/share.svg";
import { ReactComponent as Gift } from "../../../assets/images/referral/get-gifts.svg";
import { ReactComponent as GmailDark } from "../../../assets/images/gmail-dark.svg";
import { ReactComponent as InstagramDark } from "../../../assets/images/instagram-dark.svg";
import { ReactComponent as LinkedinDark } from "../../../assets/images/linkedin-dark.svg";
import { ReactComponent as YoutubeDark } from "../../../assets/images/youtube-dark.svg";
import { useTheme } from "../../../context/ThemeContext";
import { Check, Copy } from "lucide-react";
import { useDispatch } from "react-redux";
import { getReferalInfo } from "../../../redux/slices/referalSlice";
import {
  activityEnd,
  activityStart,
} from "../../../redux/slices/trackActivitySlice";
import usePageTracking from "../../../hooks/usePageTracking";

const Referral = () => {
  const { resolvedTheme } = useTheme();
  const [copied, setCopied] = useState(false);
  const [userRefData, setUserRefData] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const referralLink = `https://mapmypay.testdevurl.com/registration?ref=${userRefData?.referral_code}`;
  const referralLink = `https://app.mapmypay.com/registration?ref=${userRefData?.referral_code}`;
  // const referralLink = `http://localhost:3000/registration?ref=${userRefData?.referral_code}`;
  const shareText =
    "Join me on MapMyPay and get amazing benefits! Use my referral link:";
  const shareTitle = "Invite to MapMyPay";

  // Track Activity
  usePageTracking("REFERRAL");

  useEffect(() => {
    const payload = {
      page_name: "REFERRAL",
      platform: "web",
    };

    dispatch(activityStart(payload));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(
        activityEnd({
          page_name: "REFERRAL",
        }),
      );
    };
  }, [dispatch]);

  

  const getUserReferalInfo = async () => {
    try {
      const response = await dispatch(getReferalInfo());
      const isUserReferalData = response?.payload?.data;
      
      setUserRefData(isUserReferalData);
    } catch (error) {
      console.log(error);
      console.log("Error occured while fetching rfeeral info in referal page");
    }
  };

  useEffect(() => {
    getUserReferalInfo();
  }, []);

  const shareVia = async (platform = "native") => {
    const shareData = {
      title: shareTitle,
      text: shareText,
      url: referralLink,
    };

    if (navigator.share && platform === "native") {
      try {
        await navigator.share(shareData);
        console.log("Shared successfully");
      } catch (err) {
        console.log("Share canceled or failed", err);
      }
      return;
    }

    const urlEncoded = encodeURIComponent(referralLink);
    const textEncoded = encodeURIComponent(`${shareText} ${referralLink}`);

    const links = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${urlEncoded}`,
      twitter: `https://twitter.com/intent/tweet?text=${textEncoded}`,
      linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${urlEncoded}&title=${encodeURIComponent(
        shareTitle,
      )}&summary=${encodeURIComponent(shareText)}`,
      email: `mailto:?subject=${encodeURIComponent(
        shareTitle,
      )}&body=${encodeURIComponent(`${shareText}\n${referralLink}`)}`,
    };

    if (platform === "instagram") {
      navigator.clipboard.writeText(referralLink);
      alert("Link copied! Open Instagram app and paste it in your story/post.");
      return;
    }

    window.open(
      links[platform] || links.whatsapp,
      "_blank",
      "noopener,noreferrer",
    );
  };

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      setCopied(true);

      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      alert("Failed to copy");
    }
  };

  return (
    <>
    <NoIndexSEO title={seoConfig.referral.title} />
    <div className="contact-content referral-page">
      <div className="app-page-title">
        <div className="page-title-heading d-flex align-items-center">
          <FiArrowLeft
            size={40}
            className="icon cursor-pointer"
            // onClick={() => navigate("/profile")}
            onClick={() => navigate(-1)}
          />
          <h3 className="page-title">Referral</h3>
        </div>
      </div>

      <Card className="mb-0">
        <Card.Body className="p-0">
          <div className="referral-banner">
            <div className="left-section">
              <h2>
                Refer Friend, get a free <br />
                month of Pro
              </h2>
              <p>
                You'll receive one free month of Pro when your <br />
                friend purchases any paid plan
              </p>
            </div>

            <div className="qr-floating-wrapper">
              <div className="qr-watercolor-box">
                <QRCode
                  value={referralLink}
                  // size={156}
                  size={296}
                  bgColor="#ffffff"
                  fgColor="#000000"
                  level="M"
                />
              </div>
            </div>
          </div>

          <div className="referral-content">
            <div className="referral-input-box">
              <div className="referral-input-wrapper">
                {/* Read-only display, not an <input>: lets us horizontally
                    scroll the long URL on touch devices without the native
                    input clipping. Scrollbar is hidden via SCSS. */}
                <div
                  className="referral-link-text"
                  role="textbox"
                  aria-label="Referral link"
                  aria-readonly="true"
                  tabIndex={0}
                >
                  {referralLink}
                </div>
                <button className="copy-btn" onClick={copyToClipboard}>
                  {copied ? (
                    <>
                      Copied <Check size={18} />
                    </>
                  ) : (
                    <>
                      Copy Link <Copy size={18} />
                    </>
                  )}
                </button>
              </div>
            </div>

            <div className="social-buttons">
              <button
                className="social-btn facebook"
                onClick={() => shareVia("facebook")}
              >
                {resolvedTheme === "dark" ? <GmailDark /> : <Facebook />}
              </button>

              <button
                className="social-btn twitter"
                onClick={() => shareVia("twitter")}
              >
                {resolvedTheme === "dark" ? <InstagramDark /> : <Twitter />}
              </button>

              <button
                className="social-btn linkedin"
                onClick={() => shareVia("linkedin")}
              >
                {resolvedTheme === "dark" ? <LinkedinDark /> : <Linkedin />}
              </button>

              <button
                className="social-btn email"
                onClick={() => shareVia("email")}
              >
                {resolvedTheme === "dark" ? <YoutubeDark /> : <Mail />}
              </button>
            </div>

            <div class="innertitle-subtitle">
              <div class="inner-title pb-0">How it works</div>
            </div>

            {/* <div className="referral-label mt-5 ">How it works</div> */}
            <div className="referral-stats">
              <div className="stat-card">
                <div className="icons">
                  {" "}
                  <Share />
                </div>
                <div className="text">
                  <h3>Share your referral link</h3>
                  <p>Send your personalized link or QR code to a friend.</p>
                </div>
              </div>
              <div className="stat-card">
                <div className="icons">
                  {" "}
                  <Friend />
                </div>
                <div className="text">
                  <h3>Your friend signs up and purchases a paid plan</h3>
                  <p>They can choose either Plus or Pro.</p>
                </div>
              </div>
              <div className="stat-card">
                <div className="icons">
                  <Share />
                </div>
                <div className="text">
                  <h3>You get a free month of pro</h3>
                  <p>
                    Your free month is added to your account immediately after
                    their payment is confirmed.
                  </p>
                </div>
              </div>
            </div>

            <div class="referral-box">
              {/* <h3>Your Referral progress</h3> */}
              <div class="innertitle-subtitle">
                <div class="inner-title pb-0">Your Referral progress</div>
              </div>
              <div class="referral-row">
                <div class="referral-left">
                  <div class="ref-item">
                    <span class="label">Total Referrals:</span>
                    <span class="value">
                      {userRefData?.statistics?.total_referrals}
                    </span>
                  </div>
                  <div class="ref-item">
                    <span class="sub-label">Free Pro months earned:</span>
                    <span class="value">
                      {userRefData?.statistics?.total_rewards_earned}
                    </span>
                  </div>
                </div>
                <div class="separator"></div>

                <div class="referral-right">
                  <div class="ref-item">
                    <span class="label">Pending referrals:</span>
                    <span class="value">
                      {userRefData?.statistics?.pending_referrals}
                    </span>
                  </div>
                  <div class="ref-item">
                    <span class="sub-label">Subscribed referrered:</span>
                    <span class="value">
                      {userRefData?.statistics?.subscribed_referrals}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
    </>
  );
};

export default Referral;
